import { useWizard } from "react-use-wizard";
import BaseStep from "../../../../../shared/wizard/steps/baseStep";
import GroupButtons from "../../../../../ui/button/groupButtons";
import buySteps from "./buySteps";

const StepBuy_2 = () => {
  const { goToStep } = useWizard();

  const handleNextStep_wish = () => {
    return goToStep(buySteps.wishesSteps.step_1);
  };

  const handleNextStep_selection = () => {
    return goToStep(buySteps.selectionSteps.step_1);
  };

  const handlePrevStep = () => {
    return goToStep(buySteps.step_1);
  };

  return (
    <BaseStep text="Выбирите следующий шаг:" prevStep={handlePrevStep}>
      <GroupButtons
        data={[
          {
            onClick: () => handleNextStep_selection(),
            label: "Подбор от текущей квартиры",
            variant: "dark",
          },
          {
            onClick: () => handleNextStep_wish(),
            label: "Подбор на основании опроса",
            variant: "dark",
          },
        ]}
      />
    </BaseStep>
  );
};

export default StepBuy_2;
